module.exports = __webpack_public_path__ + "img/b82f60c.jpg";